<template>
  <div class="content">
    <ArtistSelect
      class="col-md-12"
      @memberChangeEvent="getArtistInfo"
      :show-members="false"
      :is-filter="true"
      :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
    />
    <form class="form-horizontal">
      <card class="text-left">
        <div class="row">
          <base-button @click="addRow()" type="info">행 추가</base-button>
          <base-button @click="onSubmit" type="success">등록</base-button>
          <base-button @click="copyComments()" type="success">복사</base-button>
          <el-popover trigger="hover" placement="top">
            <div>
              <div class="popover-body">
                [복사] 클릭 후 아티스트 변경하고 Ctrl+v 하면 모든 문자열이 붙여넣기 됩니다. <br />
                붙여넣기시 기존에 행이 있더라도 복사한 것과 동일하게 전체 행이 덮어쓰기됩니다.<br /><br />

                '삭제/드래그'에 있는 빨간 [-] 버튼을 드래그앤드롭하면 순서가 변경됩니다. 순서 변경 후 [등록] 버튼을 눌러야 변경 내용이 적용됩니다.<br />
              </div>
            </div>
            <base-button slot="reference"> ? </base-button>
          </el-popover>
        </div>
      </card>
      <div class="row">
        <div class="col-sm-12">
          <h2 @paste="callPasteFunctions" id="comment_area">퀵코멘트</h2>
          <div class="row">
            <div class="col-sm-3">
              <label class="col-form-label">ko</label>
            </div>
            <div class="col-sm-3">
              <label class="col-form-label">en</label>
            </div>
            <div class="col-sm-3">
              <label class="col-form-label">ja</label>
            </div>
            <div class="col-sm-2">
              <label class="col-form-label">영역</label>
            </div>
            <div class="col-sm-1"></div>
          </div>
          <hr />
          <draggable handle=".handle" v-model="list" @start="drag = true" @end="drag = false">
            <div class="row" v-for="(item, index) in list">
              <div class="col-sm-3">
                <base-input placeholder="value" v-model="item.ko">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-3">
                <base-input placeholder="value" v-model="item.en">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-3">
                <base-input placeholder="value" v-model="item.ja">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <div class="col-sm-2">
                <el-select class="select-primary" style="width: 100%" size="large" placeholder="영역" v-model="item.type">
                  <el-option v-for="option in types" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
                </el-select>
              </div>
              <div class="col-sm-1 handle">
                <base-button @click="removeRow(index)" type="danger">-</base-button>
              </div>
            </div>
          </draggable>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { BaseInput, Card } from "@/components/index";
import draggable from "vuedraggable";
import swal from "sweetalert2";

export default {
  components: {
    ArtistSelect,
    Card,
    draggable,
    BaseInput,
  },
  async created() {},
  data() {
    return {
      unitId: null,
      list: [],
      types: [
        { value: null, label: "공통" },
        { value: 210, label: "A/B" },
        { value: 220, label: "POLL" },
        { value: 221, label: "TALK" },
        { value: 222, label: "구잡담" },
        { value: 500, label: "잡담" },
        { value: 100, label: "갤러리" },
        { value: 800, label: "명언/TMI" },
        { value: 1000, label: "불판" },
        { value: 700, label: "팬로그" },
      ],
    };
  },
  methods: {
    addRow() {
      this.list.push({ type: null });
    },
    removeRow(index) {
      this.list.splice(index, 1);
    },

    copyComments() {
      const dom = document.createElement("textarea");
      document.body.appendChild(dom);
      dom.value = JSON.stringify(this.list);
      dom.select();
      document.execCommand("copy");
      document.body.removeChild(dom);
      Toast.success("클립보드에 복사되었습니다");
    },

    async getArtistInfo(param) {
      this.unitId = param.unitId;
      await this.getQuickComments();
    },

    async getQuickComments() {
      const data = await this.$axios.get(`/comments/${this.unitId}/quickComments`);
      this.list = data.data.data.map((item) => {
        if (typeof item.subtype === "number") {
          item.type = item.type + item.subtype;
        }
        return item;
      });
    },

    async onSubmit() {
      swal
        .fire({
          title: "등록 확인",
          text: `등록 하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "등록",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            const comments = this.list.map((item) => {
              if (item.type === 210) {
                item.type = 200;
                item.subtype = 10;
              } else if (item.type === 220) {
                item.type = 200;
                item.subtype = 20;
              } else if (item.type === 221) {
                item.type = 200;
                item.subtype = 21;
              } else if (item.type === 222) {
                item.type = 200;
                item.subtype = 22;
              } else {
                item.subtype = null;
              }
              return item;
            });
            await this.$axios.post(`/comments/${this.unitId}/quickComments`, { comments });
            Toast.success("등록되었습니다");
            await this.getQuickComments();
          }
        });
    },

    callPasteFunctions() {
      const me = this;
      document.getElementById("comment_area").addEventListener("paste", function (e) {
        var clipboardData, pastedData;

        // Stop data actually being pasted into div
        e.stopPropagation();
        e.preventDefault();

        // Get pasted data via clipboard API
        clipboardData = e.clipboardData || window.clipboardData;
        pastedData = clipboardData.getData("Text");

        me.list = JSON.parse(pastedData);
      });
    },
  },
};
</script>
